"use client";

import Button, { ButtonVariant } from "@/app/(components)/generics/Button/Button";
import IconDownload from "@/app/(components)/generics/Icons/IconDownload";
import IconInsoleLeft from "@/app/(components)/generics/Icons/IconInsoleLeft";
import IconInsoleRight from "@/app/(components)/generics/Icons/IconInsoleRight";
import {
  FootSide,
  ViewerStore,
} from "@/app/(components)/specifics/configurator/Configurator/ui/Viewer/ViewerStore";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";
import styles from "./ExportInsole.module.css";

type Props = { lang: string };

export default function ExportInsole(props: Props) {
  const { lang } = props;

  const exportFeet = (feet: FootSide[]) => {
    ViewerStore.getState().setExportFeet(feet);
    ModalStore.getState().closeModal();
  };

  return (
    <div className={styles.container}>
      <Button
        variant={ButtonVariant.SECONDARY}
        fullWidth
        icon={IconInsoleLeft}
        onClick={() => exportFeet([FootSide.LEFT])}
      >
        {T(TKey.FOOT_LEFT, lang)}
      </Button>
      <Button
        variant={ButtonVariant.SECONDARY}
        fullWidth
        icon={IconInsoleRight}
        onClick={() => exportFeet([FootSide.RIGHT])}
      >
        {T(TKey.FOOT_RIGHT, lang)}
      </Button>
      <Button
        variant={ButtonVariant.PRIMARY}
        fullWidth
        icon={IconDownload}
        onClick={() => exportFeet([FootSide.LEFT, FootSide.RIGHT])}
      >
        {T(TKey.EXPORT_BOTH, lang)}
      </Button>
    </div>
  );
}
